"use client";

import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import DiagramCard from "@/components/diagrams/DiagramCard";
import PlainDutchDiagram from "@/components/diagrams/PlainDutchDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
const diagramCopy = {
  sectionTitle: {
    en: "Plain Dutch Weave Micro-Geometry",
    zh: "平纹荷兰编织微观几何构造",
    es: "Microgeometría del Tejido Dutch Liso",
    de: "Mikrogeometrie der glatten Tresse",
    fr: "Microgéométrie du Tissage Reps Uni",
    pt: "Microgeometria da Trama Holandesa Lisa"
  },
  sectionLead: {
    en: "Visualizing the 1/1 interlacing of heavy warp wires and compacted fine weft wires creating triangular pore openings without direct line of sight.",
    zh: "直观展示粗经丝与紧密敲击细纬丝的 1/1 平纹交织形式，形成无直射透光通道的三角形微孔流道。",
    es: "Visualización del entrelazado 1/1 con urdimbre pesada y trama fina compacta, formando poros triangulares sin paso recto.",
    de: "Darstellung der 1/1-Bindung mit starken Kett- und dicht geschlagenen Schussdrähten zur Bildung dreieckiger Porenöffnungen.",
    fr: "Visualisation de l'armure unie 1/1 avec chaîne robuste et trame serrée créant des pores triangulaires sans ligne de visée directe.",
    pt: "Visualização do entrelaçamento 1/1 com urdume robusto e trama fina compacta, criando microporos triangulares sem passagem direta de luz."
  },
  cardTitle: {
    en: "1/1 Plain Dutch Wire Arrangement",
    zh: "1/1 平纹荷兰交织结构",
    es: "Disposición de Alambres Dutch Liso 1/1",
    de: "1/1 Glatte Tresse Drahtanordnung",
    fr: "Disposition des Fils Reps Uni 1/1",
    pt: "Disposição de Fios Holandesa Lisa 1/1"
  },
  cardDesc: {
    en: "Heavy warp wires provide longitudinal structural support while fine, touching weft wires establish the calibrated micron cutoff threshold.",
    zh: "粗径经丝提供纵向结构支撑力，相互紧贴的细纬丝精确限定微米级过滤精度。",
    es: "Los alambres gruesos de urdimbre proporcionan soporte estructural longitudinal mientras los alambres finos de trama establecen la retención calibrada.",
    de: "Starke Kettdrähte bieten Längsstabilität, während feine, aneinanderliegende Schussdrähte die exakte Filterfeinheit definieren.",
    fr: "Les gros fils de chaîne assurent la tenue longitudinale tandis que les fils fins de trame définissent le seuil de filtration étalonné.",
    pt: "Fios de urdume espessos garantem sustentação longitudinal enquanto os fios finos de trama determinam a retenção calibrada."
  }
};
export default function PlainDutchWeavePage() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, COPY);
  const diagram = <DiagramSection id="diagram" title={pick(lang, diagramCopy.sectionTitle)} lead={pick(lang, diagramCopy.sectionLead)} tone="background">
      <div className="max-w-3xl mx-auto">
        <DiagramCard index="01" badge="ISO 9044 / ASTM E2814" title={pick(lang, diagramCopy.cardTitle)} description={pick(lang, diagramCopy.cardDesc)}>
          <PlainDutchDiagram />
        </DiagramCard>
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagram} />;
}